<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-22 13:02:18
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-01-22 14:33:14
 * @Description: radio group 组件
 * @FilePath: /hsylc2021/src/components/form/RadioGroup/Prototype.vue
-->
<template>
  <div class="component-radiogroup" :class="computedClass">
    <Radio
      v-for="item in radioList"
      :key="item[keyStr]"
      :label="item._ori.label"
      v-model="item._selected"
      @input="handleClickItem"
      :_id="item._ori[keyStr]"
      :reverse="reverse"
      :disabled="item._ori.disabled || disabled"
    />
    <slot></slot>
  </div>
</template>
<script>
import clone from 'clone';
import Radio from '../Radio';
/**
 * radiogroup组件
 * @module RadioGroup
 */
export default {
  name: 'RadioGroup',
  components: {
    Radio
  },
  /**
   * @prop {String} className 组件外部class
   * @prop {Boolean} disabled 是否禁用
   * @prop {Array} value 组件数据
   * @prop {Array} options 组件来源数据列表
   * @prop {String} keyStr 唯一标志字段名，默认value
   * @prop {Boolean} reverse 是否支持反选 默认false
   * @prop {Boolean} multi 是否支持多选 默认false
   * @prop {Boolean} errmsg 报错信息 默认 未填写
   * @prop {Boolean} startVerific 是否开启验证 用户是否选择默认false
   */
  props: {
    className: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    keyStr: {
      type: String,
      default: 'value'
    },
    reverse: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: false
    }
  },
  /**
   * @prop {Object} computedClass 计算class
   * @prop {Array} radioList 根据数据源最终计算出radio数据
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      return ret;
    },
    radioList() {
      return this.options.map(item => {
        let ret = clone({
          _selected: false,
          _ori: clone(item)
        });
        if (this.value && this.value.find(_item => _item[this.keyStr] === item[this.keyStr])) {
          ret._selected = true;
        }
        return ret;
      });
    }
  },
  methods: {
    /**
     * @event input v-model input事件
     * @param {Array} 选中的对象
     */
    /**
     * @description 点击事件
     * @function handleClickItem
     * @param {String} value 点击item的value
     * @param {String} _id 点击item的key
     */
    handleClickItem: function(value, _id) {
      if (!this.disabled) {
        let ret = [];
        let radioList = clone(this.radioList).map(item => {
          let res = clone(item);
          if (res._ori[this.keyStr] === _id) {
            res._selected = value;
          } else if (!this.multi) {
            res._selected = false;
          }
          return res;
        });
        ret = radioList.filter(item => item._selected).map(item => item._ori);
        this.$emit('input', ret);
      }
    }
  }
};
</script>
<style lang="less" scoped></style>
